import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Controller } from 'react-hook-form';
import { AiFillExclamationCircle } from 'react-icons/ai';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import './s-input.component.scss';

interface SSInputPhoneCodeInterface {
  name: any;
  placeholder: string;
  error: any;
  control: any;
  rules?: any;
  international?: boolean;
  className?: string;
  defaultValue?: string;
  onChange?: any;
}

const SInputPhoneCodeComponent = ({ name, error, defaultValue, onChange, placeholder, className, control, rules, international = false }: SSInputPhoneCodeInterface) => {
  return (
    <Controller
        defaultValue={defaultValue ? defaultValue : ''}
        name={name}
        control={control}
        rules={rules}
        render={({ field }) =>
          <PhoneInput
            {...field}
            international={international}
            defaultCountry="SG"
            className="form-control d-flex"
            autoComplete="off"
            placeholder={placeholder}
            onChange={data => { field.onChange(data); onChange && onChange(data) }} />}
      />
  )
}

export default React.memo(SInputPhoneCodeComponent)
